module.exports = __webpack_public_path__ + "img/warehouse4.fe367c7c.png";